import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import heroImg from '../assets/hero_perros.png';
import ShareButton from '../components/ui/ShareButton';
import './Home.css';

const FEED_STYLES = {
  adopcion:       { ico: '🏠', badge: 'Adopción',       bg: '#ecfdf5', fg: '#047857' },
  apadrinamiento: { ico: '🐾', badge: 'Apadrinamiento', bg: '#ecfdf5', fg: '#047857' },
  voluntariado:   { ico: '🤝', badge: 'Voluntario',     bg: '#f0f9ff', fg: '#0369a1' },
  evento:         { ico: '📅', badge: 'Evento',         bg: '#f0f9ff', fg: '#0369a1' },
  donacion:       { ico: '💰', badge: 'Donación',       bg: '#fffbeb', fg: '#b45309' },
  reporte:        { ico: '🚨', badge: 'Reporte',        bg: '#fef2f2', fg: '#b91c1c' },
  reporte_validado: { ico: '✅', badge: 'Reporte validado', bg: '#f0fdf4', fg: '#047857' },
  compartir:      { ico: '🔗', badge: 'Compartido',     bg: '#f5f3ff', fg: '#6d28d9' },
  admin_ajuste:   { ico: '⚙️', badge: 'Ajuste',        bg: '#f1f5f9', fg: '#475569' }
};

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const ms = Date.now() - new Date(dateStr).getTime();
  const min = Math.floor(ms / 60000);
  if (min < 1) return 'hace un momento';
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h} h`;
  const d = Math.floor(h / 24);
  return d === 1 ? 'hace 1 día' : `hace ${d} días`;
}

export default function Home() {
  const nav = useNavigate();
  const [eventos, setEventos] = useState([]);
  const [avisos,  setAvisos]  = useState([]);
  const [actividad, setActividad] = useState([]);
  const [stats,   setStats]   = useState({ animales: 0, adopciones: 0, voluntarios: 0, urgentes: 0 });

  useEffect(() => {
    const hoy = new Date();
    api.get(`/eventos?mes=${hoy.getMonth()+1}&anio=${hoy.getFullYear()}`)
      .then(r => setEventos(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});

    api.get('/avisos').then(r => setAvisos(r.data)).catch(() => {});
    api.get('/home/estadisticas').then(r => setStats(r.data || {})).catch(() => {});
    api.get('/home/actividad').then(r => setActividad(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  const urgente = (Array.isArray(eventos) ? eventos : []).find(e => e.estado === 'rojo');

  const kpis = [
    { lbl: 'Animales rescatados', num: stats.animales,        sub: 'Registrados en la plataforma', c: 'var(--vd)' },
    { lbl: 'Adopciones',          num: stats.adopciones,      sub: 'Completadas',                 c: 'var(--a)' },
    { lbl: 'Voluntarios activos', num: stats.voluntarios,     sub: 'Dispuestos a ayudar',         c: 'var(--d)' },
    { lbl: 'Actividades urgentes', num: stats.urgentes,       sub: 'Necesitan apoyo',             c: 'var(--r)' },
  ];

  return (
    <div className="page-wrap fade-up pt-0">
      {/* BANNERS DE AVISOS */}
      {(Array.isArray(avisos) ? avisos : []).map(av => (
        <div key={av._id} className={`alert-banner b-${av.tipo}`}>
          <div className="alert-dot" />
          <p><strong>{av.titulo}:</strong> {av.mensaje}</p>
        </div>
      ))}

      {urgente && (
        <div className="alert-banner">
          <div className="alert-dot" />
          <p>🚨 <strong>Urgente:</strong> Faltan voluntarios para <strong>{urgente.nombre}</strong>
            <span className="al-link ml-2 cursor-pointer text-r underline font-extrabold" onClick={() => nav('/calendario')}> Ver actividad →</span>
          </p>
        </div>
      )}

      {/* HERO SECTION */}
      <div className="hero-premium bg-cover bg-center" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="hero-overlay absolute inset-0 bg-vd/70 z-1" />
        <div className="hero-glass relative z-2">
          <div className="hero-chips">
            <span className="hero-chip">🐾 Rescate Animal</span>
            <span className="hero-chip chip-white">🎓 Comunidad Universitaria</span>
          </div>
          <h1 className="hero-title">
            Ayuda real, <br />
            <span>impacto visible.</span>
          </h1>
          <p className="hero-desc">
            Somos una red de voluntarios dedicada al rescate, cuidado y adopción responsable. 
            <strong> Tu participación cambia vidas.</strong>
          </p>
          <div className="hero-actions">
            <button className="btn btn-v btn-lg" onClick={() => nav('/animales')}>🐾 Adoptar</button>
            <button className="btn btn-outline btn-lg" onClick={() => nav('/calendario')}>Ser voluntario</button>
            <button className="btn btn-ghost btn-lg" onClick={() => nav('/reporte')}>🚨 Reportar</button>
          </div>
        </div>
        <div className="hero-illustration">
          <div className="deco-circle circle-1" />
          <div className="deco-circle circle-2" />
        </div>
      </div>

      {/* KPI SECTION */}
      <div className="sec-header">
        <h2 className="sec-title">Impacto en la comunidad</h2>
        <p className="text-[15px] text-txs font-semibold">Cifras en tiempo real de la plataforma</p>
      </div>

      <div className="grid-4 mb-12">
        {kpis.map(k => (
          <div key={k.lbl} className="card kpi-card">
            <div className="kpi-icon" style={{ background: k.c + '15', color: k.c }}>
              {k.lbl.includes('Animales') ? '🐶' : k.lbl.includes('Adopciones') ? '🏠' : k.lbl.includes('Voluntarios') ? '🤝' : '🚨'}
            </div>
            <div className="kpi-val" style={{ color: k.c }}>{k.num}</div>
            <div className="kpi-label">{k.lbl}</div>
            <div className="kpi-sub" style={{ background: k.c + '10', color: k.c }}>{k.sub}</div>
          </div>
        ))}
      </div>

      {/* URGENT ACTIVITIES SECTION */}
      { (Array.isArray(eventos) ? eventos : []).filter(e => e.estado === 'rojo').length > 0 && (
        <div className="mb-12">
          <div className="sec-header">
            <h2 className="sec-title">Actividades Urgentes</h2>
            <p className="text-[15px] text-txs font-semibold">Necesitan voluntarios o recursos de inmediato</p>
          </div>
          <div className="grid-2">
            {(Array.isArray(eventos) ? eventos : []).filter(e => e.estado === 'rojo').map(ev => (
              <div key={ev._id} className="card urgent-card">
                <div className="urgent-badge">URGENTE</div>
                <div className="urgent-body">
                  <h3 className="urgent-title">{ev.nombre}</h3>
                  <p className="urgent-desc">{ev.descripcion}</p>
                  <div className="urgent-stats">
                    <div className="u-stat">
                      <span className="u-stat-ico">👥</span>
                      <strong>{ev.voluntariosActuales?.length || 0}/{ev.voluntariosNecesarios}</strong> voluntarios
                    </div>
                    {ev.metaFondos > 0 && (
                      <div className="u-stat">
                        <span className="u-stat-ico">💰</span>
                        <strong>${(ev.fondosActuales||0).toLocaleString()}</strong> / ${ev.metaFondos.toLocaleString()}
                      </div>
                    )}
                  </div>
                  <div className="u-actions">
                    <button className="btn btn-r u-action-main" onClick={() => nav('/calendario')}>Apoyar ahora →</button>
                    {ev.publicId && ev.validado === true && (
                      <ShareButton
                        tipo="urgente"
                        publicId={ev.publicId}
                        title={`🚨 Urgente: ${ev.nombre} — Red Cimarrona`}
                        text={`Actividad urgente de Red Cimarrona: ${ev.nombre}`}
                        data={{
                          nombre: ev.nombre,
                          descripcion: ev.descripcion,
                          ubicacion: ev.ubicacion,
                          esUrgente: true
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* RECENT ACTIVITY FEED (datos reales) */}
      <div className="sec-header">
        <h2 className="sec-title">Actividad Reciente</h2>
        <p className="text-[15px] text-txs font-semibold">Lo último que ha pasado en la plataforma</p>
      </div>
      <div className="feed-container">
        {actividad.length === 0 && (
          <div className="feed-empty">Aún no hay actividad reciente. ¡Participa para aparecer aquí!</div>
        )}
        {actividad.map((f, i) => {
          const s = FEED_STYLES[f.tipo] || FEED_STYLES.compartir;
          return (
            <div key={f.id || i} className="feed-card fade-up" style={{ animationDelay: `${i*0.1}s` }}>
              <div className="feed-ico" style={{ background: s.bg }}>{s.ico}</div>
              <div className="feed-body">
                <div className="feed-txt"><strong>{f.nombre}</strong> {f.detalle}</div>
                <div className="feed-meta">
                  <span className="feed-badge" style={{ background: s.bg, color: s.fg }}>{s.badge}</span>
                  <span className="feed-time">{timeAgo(f.fecha)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
